export default __webpack_public_path__ + "static/media/guda_logo.4f6f4cb7.png";